module.exports = __webpack_public_path__ + "static/media/TABtouch.15dff4ef.png";